<template>
  <BQdtCard
    name="homeHelp"
    type="help"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'HomeHelp',

  components: { BQdtCard },
}
</script>
